export const PRODUCT_TAGS = {
  REQUIRED_FOR_CONCURRENCY: 'requiredForConcurrencyAgentUpgrade',
  REQUIRED_FOR_SANGOMA_CX_CONCURRENCY: 'requiredForSangomaCXConcurrency',
};

export const PRODUCT_TAGS_LIST = Object.values(PRODUCT_TAGS);
